import type { CellPos } from "@heraion/shared";

// What the wide grid (#336 slice 6 part 2b) and its keys agree on: the
// handlers the web keys and the mouse call, what the keys hook gives back,
// and the cell ids on the web page. Both useGridKeys twins read it.

/** What the web keys and the mouse ask of the grid. */
export type GridKeyHandlers = {
  /** A selection is there to act on. */
  active: boolean;
  /** The open cell's field is open: its keys are its own. */
  editing: boolean;
  /** The open cell's id (gridCellId), for the focus to follow it. */
  anchorId: string | null;
  move: (dRow: number, dCol: number, extend: boolean) => void;
  /** Tab: false when the move would leave the grid, so the focus can. */
  tab: (back: boolean) => boolean;
  /** Opens the open cell's field; false when it does not open (a lens or
   *  a character that cannot be typed there), so the key stays the browser's. */
  edit: (seed?: string) => boolean;
  collapse: () => void;
  copy: () => string | null;
  paste: (text: string) => void;
  fill: (dir: "down" | "right") => void;
  /** Shift and a click: the selection grows to that cell. */
  extendTo: (p: CellPos) => void;
  /** The mouse pressed on cell `from` and dragged over cell `to`. */
  dragFrom: (from: CellPos, to: CellPos) => void;
  /** The fill handle dragged over a cell, and let go. */
  fillOver: (p: CellPos | null) => void;
  fillEnd: () => void;
  /** The context menu key (Menu, Shift+F10) or a right click, on cell `p`:
   *  the range actions open, the web's route for a screen reader. */
  contextMenu: (p: CellPos) => void;
};

export type GridKeys = {
  /** The grid's box, for the web to tell a click in it from one outside. */
  rootRef?: (node: unknown) => void;
  /** A keyboard and a mouse are there: the web. */
  hasKeys: boolean;
};

const ID = "v3gc";
/** The DOM id of a cell (RN `nativeID`), read back by the web twin. */
export const gridCellId = (p: CellPos): string => `${ID}-${p.row}-${p.col}`;
export const FILL_HANDLE_ID = `${ID}-fill`;
export const parseGridCellId = (id: string): CellPos | null => {
  const m = new RegExp(`^${ID}-(\\d+)-(\\d+)$`).exec(id);
  return m ? { row: Number(m[1]), col: Number(m[2]) } : null;
};
